import { fetchJson } from './http'

export function makeWalletsApi() {
  async function createWallet(payload) {
    await fetchJson('/api/wallet/new', { method: 'POST', body: JSON.stringify(payload) })
  }

  async function deleteWallet(publicKey) {
    await fetchJson('/api/wallet/delete', {
      method: 'POST',
      body: JSON.stringify({ public_key: publicKey }),
    })
  }

  async function listWallets(includeDeleted = false) {
    const suffix = includeDeleted ? '?include_deleted=true' : ''
    return await fetchJson(`/api/wallet/list${suffix}`)
  }

  async function restoreWallet(publicKey) {
    await fetchJson('/api/wallet/restore', {
      method: 'POST',
      body: JSON.stringify({ public_key: publicKey }),
    })
  }

  async function renameWallet(publicKey, name) {
    await fetchJson('/api/wallet/rename', {
      method: 'POST',
      body: JSON.stringify({ public_key: publicKey, name }),
    })
  }

  async function importWallet(publicKey) {
    const pk = String(publicKey || '').trim()
    if (!pk) throw new Error('public_key_required')

    const json = await fetchJson('/api/wallet/import', {
      method: 'POST',
      body: JSON.stringify({ public_key: pk }),
    })

    return {
      public_key: String(json.public_key || pk),
      private_key: String(json.private_key || ''),
    }
  }

  async function transferWallet(payload) {
    const json = await fetchJson('/api/wallet/transfer', {
      method: 'POST',
      body: JSON.stringify(payload),
    })
    return { signature: String(json.signature || '') }
  }

  async function walletTrades(publicKey, page = 1) {
    const wallet = String(publicKey || '').trim()
    if (!wallet) throw new Error('wallet_required')

    const qs = new URLSearchParams()
    qs.set('wallet', wallet)
    qs.set('owner', wallet)
    qs.set('page', String(Math.max(1, Number(page) || 1)))
    return await fetchJson(`/api/wallet/trades?${qs.toString()}`)
  }

  return { createWallet, deleteWallet, listWallets, restoreWallet, renameWallet, importWallet, transferWallet, walletTrades }
}
